import { GetAssetsByAssetIdApiResponse } from "infra/api/generated/api";

export function getIsAssetSkybox(
  asset: GetAssetsByAssetIdApiResponse["asset"] | undefined
) {
  return ["skybox-base-360", "upscale-skybox"].includes(
    asset?.metadata.type ?? ""
  );
}

export function getIsAssetInferenceTexture(
  asset: GetAssetsByAssetIdApiResponse["asset"] | undefined
) {
  return [
    "inference-txt2img-texture",
    "inference-img2img-texture",
    "inference-reference-texture",
    "inference-controlnet-texture",
  ].includes(asset?.metadata.type ?? "");
}

export function getIsAssetTexture(
  asset: GetAssetsByAssetIdApiResponse["asset"] | undefined
) {
  return (asset?.metadata.type ?? "").includes("texture");
}

export function getIsAssetUpscaledTexture(
  asset: GetAssetsByAssetIdApiResponse["asset"] | undefined
) {
  return ["upscale-texture"].includes(asset?.metadata.type ?? "");
}

export function getIsAsset3D(
  asset: GetAssetsByAssetIdApiResponse["asset"] | undefined
) {
  return asset?.metadata.kind === "3d";
}

export function getIsAssetVideo(
  asset: GetAssetsByAssetIdApiResponse["asset"] | undefined
) {
  return asset?.metadata.kind === "video";
}

export const ASSET_TYPE = {
  skybox: { singular: "skybox", plural: "skyboxes", type: "skybox" },
  texture: { singular: "texture", plural: "textures", type: "texture" },
  "3d": { singular: "3D model", plural: "3D models", type: "3d" },
  video: { singular: "video", plural: "videos", type: "video" },
  image: { singular: "image", plural: "images", type: "image" },
};

export function getAssetType(
  asset: GetAssetsByAssetIdApiResponse["asset"] | undefined
) {
  if (getIsAssetSkybox(asset)) {
    return ASSET_TYPE["skybox"];
  } else if (getIsAssetTexture(asset)) {
    return ASSET_TYPE["texture"];
  } else if (getIsAsset3D(asset)) {
    return ASSET_TYPE["3d"];
  } else if (getIsAssetVideo(asset)) {
    return ASSET_TYPE["video"];
  } else {
    return ASSET_TYPE["image"];
  }
}

export function getAssetLocaleType(
  asset: GetAssetsByAssetIdApiResponse["asset"] | undefined,
  isPlural?: boolean
) {
  const assetType = getAssetType(asset);
  return isPlural ? assetType.plural : assetType.singular;
}
